export const LOGO_URL = "/logo.png";

export const PLATFORMS = [
  { id: "Myntra", color: "#F43397" },
  { id: "Meesho", color: "#570D48" },
];

export function formatINR(v) {
  const n = Number(v || 0);
  if (Math.abs(n) >= 10000000) return `₹${(n / 10000000).toFixed(2)}Cr`;
  if (Math.abs(n) >= 100000) return `₹${(n / 100000).toFixed(2)}L`;
  if (Math.abs(n) >= 1000) return `₹${(n / 1000).toFixed(1)}K`;
  return `₹${n.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
}
